import React from 'react';
import { useNavigate } from 'react-router-dom';

import {Box, Container, List, Typography} from '@mui/material';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { route } from '/@/app/routes';


export const PaymentFailureView = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(route('/subscriptions/'));
    };

    return (
        <Container maxWidth="lg" sx={{ mb: 10 }}>
            <Typography variant="h2" sx={{ textAlign: 'center' }} gutterBottom>
                Ошибка оплаты.
            </Typography>
            <Typography variant="body2" sx={{ textAlign: 'center' }} gutterBottom>
                Попробуйте ещё раз.
            </Typography>
            <Box
                sx={{
                    mt: 2,
                    display: 'flex',
                    justifyContent: 'center',
                }}
                onClick={goBack}
            >
                <Button><ArrowBackIcon sx={{ mr:1 }}/>Вернуться</Button>
            </Box>
        </Container>
    )
}
